import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import BlogLayout from "../../components/BlogLayout";

const BlogPage4 = () => (
  <BlogLayout
    postId={6879}
    title="Leading with Purpose: A P&C Perspective"
    date="Apr 30, 2024"
    heroImage="Blog4.png"
  >
    <Box>
      <Typography
        sx={{
          fontSize: { xs: "0.9rem", md: "1rem" },
          lineHeight: 1.6,
          letterSpacing: "0.01em",
          color: "grey.700",
        }}
      >
        Leadership is often perceived through various lenses, each offering
        unique insights into what it means to inspire, guide, and empower teams.
        From the perspective of a seasoned people and culture specialist,
        leadership goes beyond the usual role of managing a workforce.
      </Typography>
    </Box>
    <Box>
      <Typography
        variant="h4"
        sx={{
          fontSize: { xs: "1.5rem", md: "1.875rem" },
          fontWeight: 700,
          color: "text.primary",
          mb: 3,
        }}
      >
        Understanding Purpose-Driven Leadership
      </Typography>
      <Typography
        sx={{
          fontSize: { xs: "0.9rem", md: "1rem" },
          lineHeight: 1.6,
          letterSpacing: "0.01em",
          color: "grey.700",
        }}
      >
        Purpose-driven leadership is more than a buzzword; it's a philosophy
        centered around aligning one's actions, decisions, and vision with a
        meaningful and greater purpose. Leaders who embrace this approach think
        about the long-term impact of their decisions on their teams,
        organizations, and the broader community.
      </Typography>
    </Box>
    <Box>
      <Typography
        sx={{
          fontSize: { xs: "0.9rem", md: "1rem" },
          lineHeight: 1.6,
          letterSpacing: "0.01em",
          color: "grey.700",
        }}
      >
        From a P&amp;C viewpoint, this type of leadership is invaluable. It
        fosters an environment where employees feel a deep connection to their
        work. When team members understand the 'why' behind their tasks, they're
        more likely to go the extra mile and contribute to a positive
        organizational culture.
      </Typography>
    </Box>
    <Box>
      <Typography
        sx={{
          fontSize: { xs: "0.9rem", md: "1rem" },
          lineHeight: 1.6,
          letterSpacing: "0.01em",
          color: "grey.700",
        }}
      >
        Another cornerstone of purpose-driven leadership is transparency. Open
        communication about challenges, successes, and even failures builds
        trust and empowers employees to take risks and innovate without fearing
        punitive consequences.
      </Typography>
    </Box>
    <Box>
      <Typography
        sx={{
          fontSize: { xs: "0.9rem", md: "1rem" },
          lineHeight: 1.6,
          letterSpacing: "0.01em",
          color: "grey.700",
        }}
      >
        So, what does this mean for you? Start by reflecting on your purpose.
        How can you align your actions with that purpose to inspire those around
        you? If you're in P&amp;C, think about how you can advocate for
        leadership that values people as much as it values profit.
      </Typography>
    </Box>
  </BlogLayout>
);

export default BlogPage4;
